<template>
  <div class="navigation-wrapper">
    <div class="navigation">
      <div class="arrow previous-event">
        <img title="previous" src="@/assets/chevron-up-circle-outline-red.svg" @click="previous"/>
      </div>
      <div class="timeline-container">
        <timeline v-if="!noTimeline" :id="id" @navigateTo="navigateTo"/>
      </div>
      <div v-if = "lastId !== id" class="arrow next-event">
        <img title="next" src="@/assets/chevron-down-circle-outline-red.svg" @click="next"/>
      </div>
    </div>
  </div>
</template>

<script>
import Timeline from '@/components/Timeline'
export default {
  name: 'navigation',
  props: ['noTimeline', 'id'],
  components: {
    Timeline
  },
  data () {
    return {
      lastId: this.$store.getters.screensData.find(event => event.isLast).slug
    }
  },
  methods: {
    next () {
      this.$store.dispatch('next')
    },
    previous () {
      this.$store.dispatch('previous')
    },
    navigateTo (id) {
      window.location.href = '#' + id
    }
  }
}
</script>

<style lang="scss">
  @media only screen and (min-width: 769px) {
    .navigation-wrapper {
      position: absolute;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      .navigation {
        width: 64px;
        margin-right: 56px;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: stretch;
        .arrow {
          text-align: right;
          flex-basis: 120px;
          img {
            cursor: pointer;
          }
        }
        .arrow.previous-event {
            margin-top: 48px;
        }
        .timeline-container {
          height: 100%;
        }
      }
    }
  }
  @media only screen and (max-width: 769px) {
    .navigation-wrapper {
      position: absolute;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      .navigation {
        height: 100%;
        width: 64px;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: stretch;
        .arrow {
          // text-align: right;
          // flex-basis: 120px;
          right: 24px;
          img {
            cursor: pointer;
          }
        }
        .arrow.previous-event {
            position: absolute;
            top: 25%;

        }
        .arrow.next-event {
          position: absolute;
            bottom: 25%;
        }
        .timeline-container {
          display: none;
        }
      }
    }
  }

</style>
